import { CurrenciesGridView } from '~/components/prices/currencies';
import { PageContainer } from '~/components/page-container';

export function Currencies() {
	return (
		<PageContainer>
			<CurrenciesGridView />
		</PageContainer>
	);
}
